export default class Anexo {
  constructor(
    id = null,
    nomeArquivo = '',
    data = '',
    conteudo = null
  ) {
    this.id = id;
    this.nomeArquivo = nomeArquivo;
    this.data = data,
    this.conteudo = conteudo
  }
}



// WEBPACK FOOTER //
// ./src/domain/recadastroDependente/anexo.js